import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { userActions } from '_actions';
import { CancelButton, ApplyButton } from '_components';
import styles from './CetsDialog.module.css';
import { Modal } from 'react-bootstrap'

class CetsDialog extends React.Component {


    punch() {
        this.props.cetsPunchIn();
    }

    punchRedirect() {
        window.location.href = 'https://time.corahealth.com';
        return null;
    }

    cancel() {
        this.props.clearCetsMessage();
    }

    render() {
        return (
            <Modal show={true} backdrop='static' keyboard={false} dialogClassName={styles.dialog}>
                {(!this.props.isPunched && (!this.props.isHardStop || this.props.isExempt)) &&
                    <>
                        <div className={styles.message}>
                            You are currently not punched in to CETS.  Would you like to punch in now?
                        </div>
                        <div className={styles.buttons}>
                            <span className={styles.button_wrapper}>
                                <ApplyButton size='small' title='Punch In' onClick={() => this.punch()} />
                            </span>
                            <span className={styles.button_wrapper}>
                                <CancelButton size='small' title='Cancel' onClick={() => this.cancel()} />
                            </span>
                        </div>
                    </>
                }
                {this.props.isHardStop && !this.props.isExempt && !this.props.isPrev2 &&
                    <>
                        <div className={styles.message}>
                            You have unassigned punches that must be addressed before you can access CORA systems. Click below to be redirected to the punch site.
                        </div>
                        <div className={styles.buttons}>
                            <span className={styles.button_wrapper}>
                                <ApplyButton size='small' title='Go to time.corahealth.com' onClick={() => this.punchRedirect()} />
                            </span>
                        </div>
                    </>
                }
                {!this.props.isPunched && this.props.isHardStop && !this.props.isExempt && this.props.isPrev2 &&
                    <>
                        <div className={styles.message}>
                            You are currently not punched in to CETS. You must punch in to use this system. Click below to punch in.
                        </div>
                        {!this.props.isPrev &&
                            <div className={styles.message}>
                                You have un-assigned punches from your last working day. Please assign these punches.
                            </div>
                        }
                        <div className={styles.buttons}>
                            <span className={styles.button_wrapper}>
                                <ApplyButton size='small' title='Punch In' onClick={() => this.punch()} />
                            </span>
                        </div>
                    </>
                }
                {this.props.isPunched && this.props.isHardStop && !this.props.isExempt && this.props.isPrev2 && !this.props.isPrev &&
                    <>
                        <div className={styles.message}>
                            You have un-assigned punches from your last working day. Please assign these punches.
                        </div>
                        <div className={styles.buttons}>
                            <span className={styles.button_wrapper}>
                                <ApplyButton size='small' title='Go to time.corahealth.com' onClick={() => this.punchRedirect()} />
                            </span>
                            <span className={styles.button_wrapper}>
                                <CancelButton size='small' title='Cancel' onClick={() => this.cancel()} />
                            </span>
                        </div>
                    </>
                }
            </Modal>
        );
    }

}

function mapStateToProps(state) {
    let isPunched = state.ui.cets.isPunchedIn;
    let isPrev = state.ui.cets.isPrevDayAssigned;
    let isPrev2 = state.ui.cets.isPrev2DayAssigned;
    let isHardStop = state.ui.cets.IsDepartmentCetsHardStop;
    let isExempt = state.ui.cets.IsUserExempt;

    return {
        isPunched,
        isPrev,
        isPrev2,
        isHardStop,
        isExempt,
    };
}

function mapDispatchToProps(dispatch) {

    return {
        cetsPunchIn: bindActionCreators(userActions.cetsPunchIn, dispatch),
        clearCetsMessage: bindActionCreators(userActions.clearCetsMessage, dispatch),

    };
}

const connectedCetsDialog = connect(mapStateToProps, mapDispatchToProps)(CetsDialog);
export { connectedCetsDialog as CetsDialog };

